"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_exports = {};
__export(types_exports, {
  DeploymentEventType: () => import_utils.DeploymentEventType,
  VALID_ARCHIVE_FORMATS: () => VALID_ARCHIVE_FORMATS,
  fileNameSymbol: () => fileNameSymbol
});
module.exports = __toCommonJS(types_exports);
var import_utils = require("./utils");
const VALID_ARCHIVE_FORMATS = ["tgz"];
const fileNameSymbol = Symbol("fileName");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DeploymentEventType,
  VALID_ARCHIVE_FORMATS,
  fileNameSymbol
});
